/**
 * Created by alvinoktavianus on 6/14/17.
 */

import React, { Component } from 'react'
import { Modal } from 'react-bootstrap'

import styles from './CancelFeatureSubscriptionModal.css'

class CancelFeatureSubscriptionModal extends Component {
  render () {
    const {showModal, featureName, hideModal, expirationDate, cancelSubscription} = this.props
    return (
      <Modal show={showModal} onHide={hideModal} dialogClassName={`${styles['dialog']} ${styles['cancel-feature-subscription-wrapper']} modal-dialog`}>
        <Modal.Header closeButton bsClass={styles['modal-header']}>
          <Modal.Title bsClass={styles['modal-title']} componentClass='div'>Cancel Subscription</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>Are you sure you want to cancel subscription for {featureName}? You can keep using this feature until <strong>{expirationDate}</strong>.</div>
        </Modal.Body>
        <Modal.Footer>
          <div>
            <button className='btn btn-default pull-left' onClick={hideModal}>Cancel</button>
            <button className='btn btn-danger' onClick={cancelSubscription}>Proceed</button>
          </div>
        </Modal.Footer>
      </Modal>
    )
  }
}

export default CancelFeatureSubscriptionModal



// WEBPACK FOOTER //
// ./app/components/CancelFeatureSubscriptionModal/CancelFeatureSubscriptionModal.js